import { Injectable } from '@angular/core';
import { Lacre } from '@tivic-team/manager-ts/dist/mob/entities/lacre/Lacre.entity';
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { LacreDTO, LacreDTOList } from '../../model/dtos/mob/lacre.dto';
import { ApiController } from '../api-controller.interface';

@Injectable()
export class LacreController implements ApiController<LacreDTO>{

	constructor() { }
	
	find(filters?: IFilter): Promise<LacreDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/lacre',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<LacreDTO>())
        );
        return request.call();
    }

    getLacres(filters?: IFilter): Promise<LacreDTOList> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/lacre/lacres',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new LacreDTOList())
        );
        return request.call();
    }
	
	get(id: number): Promise<LacreDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/lacre/:cdLacre',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLacre: id
                    }),
                }),
            }),
            new HttpResponse(new LacreDTO())
        );
        return request.call();
    }
    
    create(entity: LacreDTO): Promise<LacreDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/lacre',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new LacreDTO()
            )
        );
        return request.call();
    }

    update(entity: LacreDTO): Promise<LacreDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/lacre/:cdLacre',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLacre: entity.cdLacre
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new LacreDTO()
            )
        );
        return request.call();
    }

    createLote(entities: Array<LacreDTO>):Promise<Array<LacreDTO>>{
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/lacre/lote',
                    environment: environmentv3
                }),
                data: new JSONData(entities)
            }),
            new HttpResponse(new Array<LacreDTO>())
        );
        return request.call();
	}
    
	async delete(cdLacre:number):Promise<LacreDTO>{
        let quark = new Quark(
			new HttpDelete({
				url: new Url({
					id: 'mob/lacres/:cdLacre',
					environment: environment,
					pathParams: new JSONData({cdLacre: cdLacre})
				}),
			}),
			new HttpResponse(
				new LacreDTO()
			)
        );
        return await quark.call();
	}

	async getLacreByPrefixo(nrPrefixo: number): Promise<Lacre>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/lacres/ultimo/:nrPrefixo',
					environment: environment,
					pathParams: new JSONData({nrPrefixo: nrPrefixo})
				}),
			}),
			new HttpResponse(
				new Lacre()
			)
		);
		return await quark.call();
	}
}